export default [
	"riyadh",
	"jeddah",
	"dammam",
	"makkah",
	"madinah",
	"al_kharj",
	"al_majmaah",
	"al_quwayiyah",
	"az_zulfi",
	"shaqra",
	"thadiq",
	"hotat_bani_tamim",
	"durma",
	"wadi_ad_dawasir",
	"afif",
	"as_sulayyil",
	"taif",
	"rabigh",
	"khulais",
	"al_laith",
	"al_qunfudhah",
	"ranyah",
	"turubah",
	"al_jumum",
	"yanbu",
	"badr",
	"al_ula",
	"khaybar",
	"mahd_adh_dhahab",
	"hinakiyah",
	"khobar",
	"dhahran",
	"jubail",
	"qatif",
	"hofuf",
	"mubarraz",
	"ras_tanura",
	"abqaiq",
	"al_nairyah",
	"al_khafji",
	"al_qaisumah",
	"buraidah",
	"unaizah",
	"ar_rass",
	"al_bukayriyah",
	"al_mithnab",
	"riyadh_al_khabra",
	"al_badayea",
	"al_shimasiyah",
	"abha",
	"khamis_mushait",
	"al_namas",
	"muhayil",
	"bisha",
	"rijal_alma",
	"tanomah",
	"ahad_rafidah",
	"sarat_abidah",
	"tathlith",
	"jazan",
	"sabya",
	"abu_arish",
	"samtah",
	"baish",
	"ahad_al_masarihah",
	"al_dair",
	"farasan",
	"damad",
	"najran",
	"sharurah",
	"hubuna",
	"badr_al_janub",
	"yadamah",
	"thar",
	"al_bahah",
	"baljurashi",
	"al_mandaq",
	"al_qura",
	"al_aqiq",
	"tabuk",
	"haql",
	"duba",
	"al_wajh",
	"umluj",
	"tayma",
	"al_jawf_city",
	"sakaka",
	"northern_borders",
	"arar",
	"rafha",
	"turaif",
	"al_uwayqilah",
	"hail",
	"baqaa",
	"al_ghazalah",
	"ash_shinan",
	"unknown",
] as const
